<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Bine ați venit!</h2>
            <h4>Plăți Online</h4>
        </div>
    </div>
</div>
<div class="payments-page">
    <!-- Redirect botton for showing slug data in a separate page -->
    <!-- <button style="border-radius: 4px;padding: 4px 6px; color:red; margin: 3px 0; border:0; "
    (click)="redirectTo()">Redirect</button> -->
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section m-0">
                    <div class="section-top">
                        <h3 class="section-title">Listă plăți</h3>
                        <div class="row">
                            <!-- <div class="col">
                <button class="action-button">
                  <img src="/assets/icons/print-icon.svg" alt="Print" />
                  <span>Printați</span>
                </button>
              </div> -->
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                    (click)="rerenderDT(false)">
                                    <i class="fa-solid fa-arrows-rotate"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row p-2">
                        <div class="col mb-2">
                            <h4><strong>Filtre</strong></h4>
                            <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>CNP/CUI</mat-label>
                                            <input matInput type="text" formControlName="cnp_cui" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>DGITL ROL ID</mat-label>
                                            <input matInput type="number" formControlName="dgitl_rol_id" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Nume Cetățean</mat-label>
                                            <input matInput type="text" formControlName="cet_name" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Detalii Incluse</mat-label>
                                            <mat-select formControlName="detailsIncluded">
                                                <mat-option [value]="-1">--Toate--</mat-option>
                                                <mat-option [value]="1">DGITL</mat-option>
                                                <mat-option [value]="2">DMU</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>ID Interogare</mat-label>
                                            <input matInput type="number" formControlName="interogare_id" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>ID plată</mat-label>
                                            <input matInput type="number" formControlName="id_payment" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status referințe plată</mat-label>
                                            <mat-select formControlName="payment_status">
                                                <mat-option [value]="-1">--Toate--</mat-option>
                                                <mat-option [value]="1">Cu probleme achitare integrisoft</mat-option>
                                                <mat-option [value]="2">Problemă status în baza de date a referinței de
                                                    plată</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6 d-flex justify-content-start">
                                        <button type="button" class="btn btn-light action-button w-100"
                                            [popover]="popTemplate" [adaptivePosition]="true" container="body"
                                            boundariesElement="viewport" placement="right">
                                            <div
                                                class="d-flex justify-content-between align-items-center w-100 flex-wrap gap-1">
                                                <div class="d-flex align-items-center">
                                                    <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                                    <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{
                                                        selectedEndDate |
                                                        date :
                                                        "dd.MM.yyyy"
                                                        }}
                                                    </span>
                                                </div>
                                                <button type="button" class="btn border"
                                                    [ngClass]="{'btn-success': isActive, 'btn-warning': !isActive}">
                                                    <span *ngIf="isActive">Activ</span>
                                                    <span *ngIf="!isActive">Inactiv</span>
                                                </button>
                                            </div>
                                        </button>

                                        <!-- Popover Template below-->
                                        <ng-template #popTemplate>
                                            <div class="popover">
                                                <div class="row">
                                                    <div class="col d-flex justify-content-between">
                                                        <h2>Selectați intervalul</h2>
                                                        <div class="d-flex gap-1">
                                                            <button type="button" style="height: 40px; width: 100px"
                                                                class="btn border"
                                                                [ngClass]="{'btn-success': isActive, 'btn-warning': !isActive}"
                                                                (click)="toggleIsActive()">
                                                                <span *ngIf="isActive"
                                                                    class="active-btn-text">ACTIV</span>
                                                                <span *ngIf="!isActive"
                                                                    class="active-btn-text">INACTIV</span>
                                                            </button>
                                                            <button style="height: 40px; width: 100px"
                                                                class="btn btn-light close-btn"
                                                                (click)="closePopover()">
                                                                <img src="assets/icons/close.svg" alt="Închide"
                                                                    style="height: 20px; width: 20px" />
                                                                <span class="close-text">ÎNCHIDE</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                               
                                                <div class="row mt-2 mb-2">
                                                    <div class="col d-flex gap-1 justify-content-between">
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'last_0_days'
                                                            " (click)="setLastXDays(0)">
                                                            <span>ZIUA CURENTĂ</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'last_1_days'
                                                            " (click)="setLastXDays(1)">
                                                            <span>ZIUA ANTERIOARĂ</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'last_7_days'
                                                            " (click)="setLastXDays(7)">
                                                            <span>ULTIMELE 7 ZILE</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'current_year'
                                                            " (click)="setYear(0)">
                                                            <span>ANUL CURENT</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'all_years'
                                                            " (click)="setAllYears()">
                                                            <span>TOATĂ PERIOADA</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="datepicker-container">
                                                    <div class="col">
                                                        <div class="datepicker-header">
                                                            <div class="text">DE LA:</div>
                                                            <div class="date">
                                                                {{ selectedStartDate | date : "mediumDate" }}
                                                            </div>
                                                        </div>
                                                        <mat-card>
                                                            <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                                [(selected)]="selectedStartDate" [maxDate]="today"
                                                                [maxDate]="selectedEndDate"></mat-calendar>
                                                        </mat-card>
                                                    </div>
                                                    <div class="col">
                                                        <div class="datepicker-header">
                                                            <div class="text">PANA LA:</div>
                                                            <div class="date">
                                                                {{ selectedEndDate | date : "mediumDate" }}
                                                            </div>
                                                        </div>
                                                        <mat-card>
                                                            <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                                [maxDate]="today"></mat-calendar>
                                                        </mat-card>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-start my-md-0 my-2">
                                        <button type="submit" class="col-md-6 d-flex justify-content-center align-items-center action-button w-100"
                                            [disabled]="isLoading">
                                            <ng-container *ngIf="!isLoading">
                                                <i class="fa-solid fa-search me-2"></i>
                                                <span>Caută</span>
                                            </ng-container>
    
                                            <ng-container *ngIf="isLoading">
                                                <mat-spinner diameter="30"></mat-spinner>
                                            </ng-container>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="col mb-2">
                            <div class="d-flex justify-content-start flex-column">
                                <div class="row ms-0 me-0 border">
                                    <div class="col p-2 d-flex justify-content-end">DGITL: </div>
                                    <div class="col p-2 bg-danger text-white">{{totalDGITL | number: '1.2-2'}} RON</div>
                                </div>
                                <div class="row ms-0 me-0 border">
                                    <div class="col p-2 d-flex justify-content-end">DMU: </div>
                                    <div class="col p-2 bg-info text-white">{{totalDMU | number: '1.2-2'}} RON</div>
                                </div>
                                <div class="row ms-0 me-0 border">
                                    <div class="col p-2 d-flex justify-content-end">Total: </div>
                                    <div class="col p-2 bg-success text-white">{{total | number: '1.2-2'}} RON</div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-start align-items-start gap-2 mt-3 flex-wrap">
                                <form [formGroup]="tranzactiiDateForm" class="mb-1 row">
                                        <div class="col-xl-6">
                                            <mat-form-field>
                                                <mat-label>Dată început tranzacții</mat-label>
                                                <input matInput [matDatepicker]="pickerTranzactii1"
                                                    formControlName="dateFrom" readonly
                                                    (focus)="pickerTranzactii1.open()" />
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="pickerTranzactii1"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerTranzactii1></mat-datepicker>
                                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-xl-6">
                                            <mat-form-field>
                                                <mat-label>Dată sfârșit tranzacții</mat-label>
                                                <input matInput [matDatepicker]="pickerTranzactii2"
                                                    formControlName="dateEnd" readonly
                                                    (focus)="pickerTranzactii2.open()" />
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="pickerTranzactii2"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerTranzactii2></mat-datepicker>
                                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                            </mat-form-field>
                                        </div>
                                </form>
                                <button class="action-button mt-2" (click)="downloadCSV(1)">Descarcă Tranzacții
                                    Listă</button>
                                <button class="action-button mt-2" (click)="downloadCSV(2)">Descarcă Tranzacții
                                    IBAN-uri</button>
                            </div>

                            <div class="d-flex flex-column justify-content-start mt-3 gap-2">
                                <div>Legendă:</div>
                                <i style="color: red;">Filtru: Status referințe plată se supune
                                    Datepickerului, și
                                    anume
                                    intervalului de
                                    plată selectat</i>
                                <i style="color: red;">Filtru: ID Interogare si ID Plată nu ține cont de
                                    intervalul de
                                    plată selectat
                                </i>
                                <mat-divider></mat-divider>
                                <i class=""><span style="color: red;">Plata nu a fost înregistrată în
                                        sistem
                                        Integrisoft.</span> -
                                    Reprezintă
                                    imposibilitatea de a genera plata în sistemul Integrisoft</i>
                                <i class=""><span style="color: red;">Problema salvare plată în
                                        sistem.</span> - Necesită
                                    intervenția tehnicului în
                                    baza de date</i>
                            </div>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>